export const getPrice = (price?: number, isNullable?: boolean) =>
    (isNullable ? price !== undefined : price)
        ? new Intl.NumberFormat('ru-RU', { currency: 'RUB', style: 'currency' }).format((price as number) / 100)
        : '';
